import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'integrationType'
})
export class IntegrationTypePipe implements PipeTransform {
  transform(value: string): string {
    const mapping: Record<string, string> = {
      'ra': 'Road Aware',
      'ps': 'Platform Science'
    };

    return mapping[value] ?? value;
  }
}
